module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('carousel', {
    attrs: {
      "ratio": 120 / 320,
      "surface": _vm.items
    }
  }), _vm._v(" "), _c('carousel', {
    attrs: {
      "ratio": 120 / 320
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('carousel-item', {
      attrs: {
        "imgUrl": item.imgUrl
      }
    })
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ffdf9c10!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/carousel/demo.vue
// module id = 285
// module chunks = 15